function none() {}

export default function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-selection/src/selector.js
// module id = 85
// module chunks = 0 1 2 3 4